import React from 'react'
import { useAuth } from '../../molecules/Auth'
import useBranchOffices from '../../../hooks/useBranchOffice'
import SelectFieldFilter from '../../molecules/filters/SelectFieldFilter'
import { isNotSuccessful } from '../../../hooks/useQuery'

const MyBranchOfficeFilter = () => {
  const { user } = useAuth()
  const { getBranchOffices } = useBranchOffices(user.institution_id)
  const { data: branchOffices, status } = getBranchOffices()

  if (isNotSuccessful(status)) return null

  return (
    <>
      <SelectFieldFilter
        className="min-w-60 mb-5 mt-3"
        label="Sede"
        name="attended_branch_office_id"
        margin="none"
        size="full"
        emptyLabel="Todas"
        options={branchOffices}
      />
    </>
  )
}

export default MyBranchOfficeFilter
